import { ManageByPerpetual } from './../models/imanage.model';
import { ManageService } from './../services/manage.service';
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute } from '@angular/router';
import { 
  Component,
  OnInit, 
  ComponentRef, 
  ViewChild, 
  ViewContainerRef, 
  OnDestroy
 } from '@angular/core';
import { IMenu } from '../models/imenu.model';
import { Observable, from } from 'rxjs';
import { NgProgressService } from '../services/ngProgress.service';

@Component({
  selector: 'app-manage-perpetuals',
  templateUrl: './manage-perpetuals.component.html',
  styleUrls: ['./manage-perpetuals.component.css']
})
export class ManagePerpetualsComponent implements OnInit, OnDestroy {

  MENULIST: IMenu[] = [
    {
      menuName: 'ESD',
      menuIcon: 'far fa-circle',
      menuRouter: 'managePerpetualsProgramtypes/ESD'
    }
  ];

  menulist$: Observable<IMenu[]>;
  title = 'PERPETUALS';
  created = false;
  // closesub$;
  // the component can be any instance of the child component in the second menu
  component: ComponentRef<any>;

  
  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

   // css variable
   setFullWindow = false;
   subWidth: string;
 
   searchField = '';

  constructor(
    private activeRouter: ActivatedRoute,
    private manageService: ManageService,
    private ngProgress: NgProgressService
  ) {
    this.menulist$ = from([this.MENULIST]);
   }

  ngOnInit() {
    this.ngProgress.start();

    this.activeRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }
    });

    //Murali - DCOEM - NOT REQUIRED Get DCOEM items first to determine if menu list should load it
    // this.manageService.getPerpetualsByType('DCOEM').subscribe((value: ManageByPerpetual[]) => {

    //   if (value.length > 0)
    //       this.MENULIST.push(    
    //         {
    //           menuName: 'DCOEM',
    //           menuIcon: 'far fa-circle',
    //           menuRouter: 'managePerpetualsProgramtypes/DCOEM'
    //         }
    //       );
            
    //   this.ngProgress.done();
    // },
    // (error: any) => {
    //     console.info(error);
    //     this.ngProgress.done();
    // });
  }

    // TODO:
    // need to add the dbouncetime event on the observable
    filterMenu(menuName: string) {
      if (menuName.length > 0) {
        console.log('this is', menuName);
        this.menulist$ = from([
          this.MENULIST.filter(item => {
            return (
              item.menuName.toUpperCase().indexOf(menuName.toUpperCase()) >= 0
            );
          })
        ]);
        // .pipe(debounceTime(1000));
        // .debounceTime(1000);
      } else {
        this.menulist$ = from([this.MENULIST]);
      }
    }
  
    ngOnDestroy(): void {
      // this.closesub$.unsubscribe();
    }
  
    close() { this.ngProgress.done();
      this.entry.clear();
      this.created = false;
    }

}
